
import Checklist from 'vux/src/components/checklist/index.vue'

export default {
components: {
Checklist
},
data() {
return {
checkListModel: ['China', 'Japan', 'America'],
checkSelectModel: ['China', 'Japan'],
}
},
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-check.vue